"use client";

import { DirectionProvider } from "@radix-ui/react-direction";

export default DirectionProvider;
